import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'

import Settings from 'src/pages/Settings.vue'
import SignIn from 'src/pages/Signin.vue'
import MailSend from 'src/pages/MailSend.vue'
import MailSendCreate from 'src/pages/MailSendCreate.vue'

import FromMails from 'src/pages/FromMails/FromMails.vue'
import FromMailsList from 'src/pages/FromMails/FromMails.list.vue'
import FromMailsCreate from 'src/pages/FromMails/FromMails.create.vue'
import FromMailsEdit from 'src/pages/FromMails/FromMails.edit.vue'

import Mails from 'src/pages/Mails/Mails.vue'
import MailsList from 'src/pages/Mails/Mails.list.vue'
import MailsCreate from 'src/pages/Mails/Mails.create.vue'
import MailsEdit from 'src/pages/Mails/Mails.edit.vue'

import MailTemplate from 'src/pages/MailTemplates/MailTemplates.vue'
import MailTemplateList from 'src/pages/MailTemplates/MailTemplates.list.vue'
import MailTemplateCreate from 'src/pages/MailTemplates/MailTemplates.create.vue'
import MailTemplateEdit from 'src/pages/MailTemplates/MailTemplates.edit.vue'
import MailQueue from 'src/pages/MailQueues/MailQueues.vue'
import MailQueueList from 'src/pages/MailQueues/MailQueues.list.vue'

import MailGroup from 'src/pages/MailGroups/MailGroups.vue'
import MailGroupList from 'src/pages/MailGroups/MailGroups.list.vue'
import MailGroupCreate from 'src/pages/MailGroups/MailGroups.create.vue'
import MailGroupEdit from 'src/pages/MailGroups/MailGroups.edit.vue'
import Categories from 'src/pages/Categories/Categories.vue'
import CategoriesList from 'src/pages/Categories/Categories.list.vue'
import CategoriesCreate from 'src/pages/Categories/Categories.create.vue'
import CategoriesEdit from 'src/pages/Categories/Categories.edit.vue'

import Items from 'src/pages/Items/Items.vue'
import ItemsList from 'src/pages/Items/Items.list.vue'
import ItemsCreate from 'src/pages/Items/Items.create.vue'
import ItemsEdit from 'src/pages/Items/Items.edit.vue'

import Companies from 'src/pages/Companies/Companies.vue'
import CompaniesList from 'src/pages/Companies/Companies.list.vue'
import CompaniesCreate from 'src/pages/Companies/Companies.create.vue'
import CompaniesEdit from 'src/pages/Companies/Companies.edit.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview'
  },
  {
    path: '/signin',
    name: 'Sign In',
    component: SignIn
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'fromMails',
        component: FromMails,
        redirect: '/fromMails',
        children: [
          {
            path: '',
            name: 'fromMails.List',
            component: FromMailsList,
          },
          {
            path: 'create',
            name: 'fromMails.Create',
            component: FromMailsCreate,
          },
          {
            path: ':id',
            name: 'fromMails.Edit',
            component: FromMailsEdit,
          }
        ]
      },
      {
        path: 'mails',
        component: FromMails,
        redirect: '/fromMails',
        children: [
          {
            path: '',
            name: 'mails.List',
            component: MailsList,
          },
          {
            path: 'create',
            name: 'mails.Create',
            component: MailsCreate,
          },
          {
            path: ':id',
            name: 'mails.Edit',
            component: MailsEdit,
          }
        ]
      },
      {
        path: 'mailtemplates',
        component: MailTemplate,
        redirect: '/mailTemplates',
        children: [
          {
            path: '',
            name: 'mailTemplates.List',
            component: MailTemplateList,
          },
          {
            path: 'create',
            name: 'mailTemplates.Create',
            component: MailTemplateCreate,
          },
          {
            path: ':id',
            name: 'mailTemplates.Edit',
            component: MailTemplateEdit,
          }
        ]
      },
      {
        path: 'mailqueues',
        component: MailQueue,
        redirect: '/mailQueues',
        children: [
          {
            path: '',
            name: 'mailqueues.List',
            component: MailQueueList,
          },
        ]
      },
      {
        path: 'mailgroups',
        component: MailGroup,
        redirect: '/mailgroups',
        children: [
          {
            path: '',
            name: 'mailgroups.List',
            component: MailGroupList,
          },
          {
            path: 'create',
            name: 'mailgroups.Create',
            component: MailGroupCreate,
          },
          {
            path: ':id',
            name: 'mailgroups.Edit',
            component: MailGroupEdit,
          }
        ]
      },
      {
        path: 'categories',
        component: Categories,
        redirect: '/categories',
        children: [
          {
            path: '',
            name: 'categories.List',
            component: CategoriesList,
          },
          {
            path: 'create',
            name: 'categories.Create',
            component: CategoriesCreate,
          },
          {
            path: ':id',
            name: 'categories.Edit',
            component: CategoriesEdit,
          }
        ]
      },
      {
        path: 'items',
        component: Items,
        redirect: '/items',
        children: [
          {
            path: '',
            name: 'items.List',
            component: ItemsList,
          },
          {
            path: 'create',
            name: 'items.Create',
            component: ItemsCreate,
          },
          {
            path: ':id',
            name: 'items.Edit',
            component: ItemsEdit,
          }
        ]
      },
      {
        path: 'companies',
        component: Companies,
        redirect: '/companies',
        children: [
          {
            path: '',
            name: 'companies.List',
            component: CompaniesList,
          },
          {
            path: 'create',
            name: 'companies.Create',
            component: CompaniesCreate,
          },
          {
            path: ':id',
            name: 'companies.Edit',
            component: CompaniesEdit,
          }
        ]
      },
      {
        path: 'mailsend',
        name: 'MailSend',
        component: MailSend
      },
      {
        path: 'mailsendCreate',
        name: 'MailSendCreate',
        component: MailSendCreate
      },
      {
        path: 'table-list',
        name: 'Table List',
        component: TableList
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      }
    ]
  },
  { path: '*', component: NotFound }
]


export default routes
